module.exports = __webpack_public_path__ + "img/app_secret.61a352c8.png";